"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logo = exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  theme
}) => ({
  boxShadow: (0, _util.boxShadow)(theme, [0, -1, 0, 0, 'ui3', true]),
  height: 64,
  width: '100%'
});

exports.wrapper = wrapper;

const logo = ({
  theme
}) => ({
  margin: (0, _util.spacing)(theme, ['none', 'xxlarge', 'none', 'xlarge']),
  cursor: 'pointer'
});

exports.logo = logo;
//# sourceMappingURL=NavBar.style.js.map